// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DnaSyngoviaComponent } from 'src/app/modules/dna-syngovia/components/dna-syngovia/dna-syngovia.component';
import { ScreenLayoutService } from 'src/app/modules/shared/services/screen-layout-service/screen-layout.service';
import { SystemOverviewService } from '../../services/systemOverview.service';
import { CompanionsPanelComponent } from '../companions-panel/companions-panel.component';
import { DocBoxPanelComponent } from '../docBoxPanel/docBoxPanel.component';
import { PlannedActivitiesPanelComponent } from '../planned-activities-panel/planned-activities-panel.component';
import { UsefulApplications } from '../useful-applications/useful-applications';
import { SparePartsPanelComponent } from 'src/app/modules/spare-parts/spare-parts-panel/spare-parts-panel.component';

@Component({
  standalone: true,
  selector: 'app-system-overview-syngovia',
  templateUrl: './system-overview-syngovia.component.html',
  styleUrls: [
    '../system-overview/system-overview.component.scss',
    './system-overview-syngovia.component.scss',
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DnaSyngoviaComponent,
    DocBoxPanelComponent,
    CompanionsPanelComponent,
    UsefulApplications,
    PlannedActivitiesPanelComponent,
    TranslateModule,
    SparePartsPanelComponent,
  ],
})
export class SystemOverviewSyngoviaComponent {
  public systemDetails$ = this.systemOverviewService.systemDetails.data$;

  public constructor(
    protected readonly systemOverviewService: SystemOverviewService,
    protected readonly screenLayoutService: ScreenLayoutService,
  ) {}
}
